import React, {useCallback} from "react";
import {Input} from "antd";
import {NumericFormat, NumericFormatProps} from "react-number-format";
import {useGetUserProfileQuery} from "../../../redux/api/locales";

export default function SingleNumberFilter({activeValue, suffix, displayText, decimalScale, onChange}: {
  activeValue: number | undefined,
  suffix: string,
  displayText: string,
  decimalScale: number | undefined,
  onChange: (value: number | string | undefined) => void
}) {

  const {data} = useGetUserProfileQuery();
  let props: NumericFormatProps<any> = {
    customInput: Input,
    decimalScale: decimalScale,
  };

  if (data?.language === 'it') {
    props = {
      thousandSeparator: '.',
      decimalSeparator: ',',
      ...props,
    };
  }

  const handleChange = useCallback((value: number | undefined) => {
    onChange(value);
  }, [onChange]);


  return <>
    <p>{displayText}</p>
    <NumericFormat
      value={activeValue ?? ""}
      suffix={" " + suffix}
      onValueChange={values => handleChange(values.floatValue)}
      {...props}
    />
  </>
}